exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".planned-lesson-row .max-width-column{max-width:110px}.planned-lesson-row .remaining-places small{font-size:.7em}.planned-lesson-row .planned-lesson-schedule{max-width:160px}", ""]);

// exports
